import type { ThemeData } from 'src/pages/procurer/preferences/Themes/schema';
import type { ImpactData, PreferencesStep } from 'src/store/preferencesStore';
import type { ScoringData } from 'src/pages/procurer/preferences/Scoring/schema';
import type { GeographyData } from 'src/pages/procurer/preferences/Geography/schema';
import type { FinalizingData } from 'src/pages/procurer/preferences/Finalizing/schema';
import type { QualitativeData } from 'src/pages/procurer/preferences/Qualitative/schema';
import type { Doc, FileWithUrl, ContractPreferencesCurrentStep as CurrentStep } from 'src/types';

import { axios, formatError } from './utils';

interface SavePreferencesApiResponse {
  message: string;
}

// Override GeographyData to use string[] for geographicalAreas
type GeographyDataWithArray = Omit<GeographyData, 'geographicalAreas'> & {
  geographicalAreas: string[];
};

export interface PreferencesData {
  currentStep: CurrentStep;
  geography?: GeographyDataWithArray;
  themes?: ThemeData[];
  impact?: ImpactData | null;
  scoring?: ScoringData | null;
  qualitative?: QualitativeData | null;
  finalizing?: FinalizingData;
  completedSteps?: PreferencesStep[];
  privacyDocument?: FileWithUrl | null;
  privacyDocumentUpdatedAt?: string | null;
  error?: any;
}

export async function getPreferences(): Promise<PreferencesData> {
  try {
    const response = await axios.get('/api/procurer/preferences');
    return response.data.data;
  } catch (error) {
    const err = formatError(error);
    throw err;
  }
}

export async function savePreferences(data: PreferencesData): Promise<SavePreferencesApiResponse> {
  try {
    const response = await axios.post('/api/procurer/preferences', data);
    return response.data;
  } catch (error) {
    const err = formatError(error);
    throw err;
  }
}

export async function savePrivacyPolicy(privacyDocument: Doc) {
  try {
    const response = await axios.put('/api/procurer/preferences/privacy-policy', {
      privacyDocument,
    });
    return response.data.data;
  } catch (error) {
    throw formatError(error);
  }
}
